import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { renderIf } from "modules/render-if";
import buttons from "shared-styles/buttons.scss";
import classes from "./index.scss";
import classNames from "classnames";
import validationClasses from "shared-components/FormFields/shared.scss";
import dvfp from "modules/deviceFingerprint";
import scroll from "modules/scroll";

import { NAME as CHECKLIST_NAME } from "shared-components/Checklist/const";
import FIELD_NAME from "shared-components/FormFields/const";
import Checklist from "shared-components/Checklist";
import FormField from "shared-components/FormFields";
import Field from "shared-components/FormFields/helpers";
import validators from "./lib/validators";

import { TERMS_STATE, PAGES } from "apps/termsOfUseAcceptance/lib/constants";

const NAVBAR_HEIGHT = 60;

function generateFingerprint(component) {
  if (dvfp.isReady()) {
    dvfp
      .generate()
      .then((fingerprint) => component.setState({ dvfp: fingerprint }));
  } else {
    setTimeout(() => generateFingerprint(component), 1000);
  }
}

function isField(type) {
  for (const key in FIELD_NAME.FIELD) {
    if (type === FIELD_NAME.FIELD[key]) return true;
  }
  return false;
}

function validateFields(fields) {
  let allFieldsValid = true;
  const newFields = [];

  for (let field of fields) {
    if (field.validations) {
      const { valid, error, validations } = validators.runValidations(
        field.validations,
        field.value,
        fields
      );
      newFields.push({
        ...field,
        props: {
          ...field.props,
          valid,
          error,
        },
        validations,
      });
      allFieldsValid = allFieldsValid && valid;
    } else {
      newFields.push(field);
    }
  }

  return { valid: allFieldsValid, fields: newFields };
}

class SignupPage extends Component {
  constructor(props) {
    super(props);
    const query = window.location.search;
    const searchParams = new URLSearchParams(query);
    if (searchParams.get("gifting")) {
      this.state = {
        isGifting: true,
        gifter: searchParams.get("gifter"),
      };
    }
  }

  state = {
    dvfp: undefined,
    passwordScore: -1,
    isReferral: false,
    hasGcProgram: undefined,
    hasGcProgramError: false,
  };

  componentWillMount() {
    const Actions = this.props.Actions;
    this.props.dispatch(Actions.terms.setPage(PAGES.SIGNUP));
  }

  componentDidMount() {
    generateFingerprint(this);
    this.checkIfReferral();
  }

  componentDidUpdate() {
    const termsModalShown =
      this.props.terms.termsState === TERMS_STATE.SHOW_MODAL;
    const userSubmit = this.props.terms.submit === true;
    const userAcceptedTerms = this.props.terms.userAccepted === true;
    const termsAccepted = userSubmit && userAcceptedTerms;
    const bodyScrollLocked = scroll.isBodyScrollLocked();

    if (termsModalShown) {
      scroll.lockBodyScroll();
    } else if (!termsModalShown && bodyScrollLocked) {
      scroll.unlockBodyScroll();
      window.scrollTo(0, 0);
    }

    if (termsAccepted === true) return this.$form.submit();
  }

  submitClick = (e) => {
    e.preventDefault();
    const Actions = this.props.Actions;
    const { valid, fields } = validateFields(this.props.model);

    if (valid) return this.props.dispatch(Actions.terms.signupClick());

    this.props.dispatch(Actions.signup.submitError(fields));
    setTimeout(() => {
      const $firstErrorEl = window.document.querySelector(
        `.${validationClasses["validation-invalid"]}`
      ).parentNode;
      scroll.scrollToElement($firstErrorEl, NAVBAR_HEIGHT);
    }, 50);
  };

  onFocus = (e) => {
    const key = e.target.getAttribute("data-key");
    this.props.dispatch(this.props.Actions.signup.fieldFocus(key));
  };

  onBlur = (e, val) => {
    const field = { key: e.target.getAttribute("data-key"), value: val };
    const linkedKey = e.target.getAttribute("data-linkto-key");
    const linkTo = {};
    if (linkedKey) {
      linkTo.key = linkedKey;
      linkTo.value = Field.removeNonDigits(val);
    }
    this.props.dispatch(this.props.Actions.signup.fieldBlur(field, linkTo));
  };

  onInput = (e, val) => {
    const key = e.target.getAttribute("data-key");
    if (key !== "Password") {
      return;
    }
    let passwordField = this.props.model[3];
    if (passwordField.key !== "Password")
      throw new Error("Invalid index for 'Password'");

    const passwordValidations = validators.runChecklistValidations(
      passwordField.validations,
      val
    );
    let passwordScore = -1;
    for (let passwordValidation of passwordValidations) {
      if (passwordValidation.passed === true) {
        passwordScore += 1;
      }
    }

    this.setState({ passwordScore: passwordScore });
    const Actions = this.props.Actions;
    this.props.dispatch(Actions.signup.passwordInput(key, val));
  };

  checkIfReferral = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const isReferral = urlParams.get("referral_code");
    if (isReferral) {
      this.setState({ isReferral: true });
      const facebookButton = document.querySelectorAll(".btn-facebook")[0];
      if (facebookButton) {
        const wrapper = facebookButton.parentElement;
        wrapper.parentElement.removeChild(wrapper);
      }
    }
  };

  formFields(fieldsModel) {
    return fieldsModel.map((model) => {
      const isPasswordInputField =
        model.type === FIELD_NAME.FIELD.PASSWORD_WITH_METER;

      const options = { ...model };
      if (isPasswordInputField) {
        options.props.passwordScore = this.state.passwordScore;
        options.props.onInput = this.onInput;
      }
      if (isField(model.type)) {
        options.props.onInput = this.onInput;
        options.props.onBlur = this.onBlur;
        options.props.onFocus = this.onFocus;
      }

      return FormField.create[options.type](options);
    });
  }

  termsOfUseAcceptanceInput(val) {
    return FormField.create[FIELD_NAME.ELEMENT.INPUT]({
      key: "TermsOfUseAcceptance",
      props: {
        type: "hidden",
        name: "user[accepted_terms]",
        value: val,
      },
    });
  }

  toggleTermsModal = (event) => {
    event.preventDefault();
    const Actions = this.props.Actions;
    this.props.dispatch(Actions.terms.termsClick());
  };

  handleHideErrorHasGcProgramTrue = () => {
    this.setState({ hasGcProgram: true });
    this.setState({ hasGcProgramError: false });
  };

  handleHideErrorHasGcProgramFalse = () => {
    this.setState({ hasGcProgram: false });
    this.setState({ hasGcProgramError: false });
  };

  render() {
    const { model, terms, data } = this.props;
    const { isReferral } = this.state;
    const passReferral = isReferral ? location.search : "";

    const formProps = {
      id: "signup-form",
      action: `${data.signupUrl}${passReferral}`,
      onSubmit: this.submitClick,
      method: "post",
      autoComplete: "off",
      ref: (r) => (this.$form = r),
    };

    const submitClasses = `btn btn-primary ${classes.btn}`;
    const submitProps = {
      id: "signup-button",
      className: submitClasses,
      name: "commit",
      onClick: this.submitClick,
    };

    const wrapperClasses = classNames({
      ["login-signup"]: true,
      [classes["form-wrapper"]]: true,
    });

    return (
      <Fragment>
        <div className={wrapperClasses}>
          <h1 className="centered">Sign Up</h1>
          {this.state.isGifting && (
            <div className="giftingNotification">
              <div className="giftingNotificationHeader">
                <span>Surprise!</span>
                <span>{`You received a gift from ${this.state.gifter}`}.</span>
              </div>
              <div className="giftingNotificationText">
                Fill in the fields below to set up your account and access your
                gift card.
              </div>
            </div>
          )}
          {renderIf(!data.isReferral && !this.state.isGifting)(() => (
            <p className="centered">
              Already a GCX member?{" "}
              <a href={`${data.loginPath}`} class="hyperlink">
                <strong>Log In</strong>
              </a>
            </p>
          ))}

          <form {...formProps}>
            {this.formFields(model)}
            {this.termsOfUseAcceptanceInput(terms.submit && terms.userAccepted)}
            <input
              type="hidden"
              name="user_registration_form[dvfp]"
              value={this.state.dvfp}
            />
            <input
              type="hidden"
              name="user_registration_form[password_score]"
              value={this.state.passwordScore}
            />
            <div className={classes.termsContainer}>
              <span>
                By joining, I agree to GCX's&nbsp;
                <button
                  className={classes.termsLink}
                  onClick={this.toggleTermsModal}
                  type="button"
                >
                  Terms of Use.
                </button>
              </span>
            </div>
            <button {...submitProps}>Continue</button>
          </form>
        </div>
        {isReferral && (
          <section className="referal-education">
            <div className="referal-education__text">
              <h3 className="referal-education__subtitle">TWO WAYS TO SAVE</h3>
              <h2 className="referal-education__title">
                Buy gift cards for yourself and save every day.
              </h2>
              <h4 className="referal-education__title--minor">DISCOUNT</h4>
              <p className="referal-education__desc">
                Buy discounted gift cards and save up to 30% at thousands of
                your favorite stores.
              </p>
              <h4 className="referal-education__title--minor referal-education__desc--lessMargin">
                GCX Cash
              </h4>
              <p className="referal-education__desc">
                Buy gift cards at face value and get up to 10% back in Raise
                Cash to spend on future purchases.
              </p>
            </div>
            <img
              alt=""
              className="referal-education__image"
              src="/assets/refer_friend.png"
            />
          </section>
        )}
      </Fragment>
    );
  }
}

SignupPage.propTypes = {};

export default SignupPage;
